import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_THREAD_LIST_MEMBER_DETAILS = createAsyncActionTypes('FETCH_THREAD_LIST_MEMBER_DETAILS');
export const FETCH_FILTER_RULES_BY_THREAD_ID = createAsyncActionTypes('FETCH_FILTER_RULES_BY_THREAD_ID');